import { render, staticRenderFns } from "./SayWeeeAuthorize.vue?vue&type=template&id=b04b322a&scoped=true&"
import script from "./SayWeeeAuthorize.vue?vue&type=script&lang=js&"
export * from "./SayWeeeAuthorize.vue?vue&type=script&lang=js&"
import style0 from "./SayWeeeAuthorize.vue?vue&type=style&index=0&id=b04b322a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04b322a",
  null
  
)

export default component.exports